export default "__VITE_ASSET__CBeiQjeo__"